import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createLab",
    serviceName: "admin",
    query: gql`
      mutation createLab(
        $title: String!
        $alias: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $status_id: String
        $is_active: Int
        $manager_id: String # $local_info: String # $support_info: String # $management_info: String
      ) # $configs: String
      # $shipping_cost_config: String
      # $request_id: String
      # $creator_id: String
      {
        createLab(
          title: $title
          alias: $alias
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          status_id: $status_id
          is_active: $is_active
          manager_id: $manager_id # local_info: $local_info # support_info: $support_info # management_info: $management_info
        ) # configs: $configs
        # shipping_cost_config: $shipping_cost_config
        # request_id: $request_id
        # creator_id: $creator_id
        {
          messages
        }
      }
    `,
  },
};

export default schema;
